import { AdUnit } from "../types/prebid";
import { SlotSizeConfig } from "../types/publisher";
import BaseBidder from "./BaseBidder";

export default class pubmatic extends BaseBidder {

	protected additionalSlotSizes: SlotSizeConfig = {
		top: {
			desktop: [[970, 1000], [1800, 1000]],
			tablet:  [],
			mobile:  []
		}
	}

	protected adUnitConfig: AdUnit = {
		code: this.slot.path,

		ssp: "Pubmatic",

		mediaTypes: {
			banner: {
				sizes: this.getAdUnitSizes()
			}
		},
		
		bids: [
			{ 
				bidder: "pubmatic", 
				params: {
					publisherId: '158160',
					adSlot: this.bidderConfig.toString()
				}
			}
		]		
	}
}
